import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section, SectionHeading } from '../Section';
import { CtaButton } from '../CtaButton';
import { playbooks } from '../../data/playbooks';
export function Playbooks() {
  return <Section tone="darker" id="playbooks" data-id="element-259" data-mp="2cmqg60j8gg93">
      <SectionHeading eyebrow="📘 What’s inside" title="The 6 Oclusion Clinical Playbooks™" subtitle="Each playbook takes one part of a complex case and turns it into a sequence you can actually follow." data-id="element-260" data-mp="2hmmjryo0q5o4" />

      <div className="mt-10 space-y-5" data-id="element-261" data-mp="27ooud7ufa2tx">
        {playbooks.map(playbook => <article key={playbook.number} className="overflow-hidden rounded-2xl border border-white/10 bg-navy-900" data-id="element-262" data-mp="1tp72gjlty9gc">
            <div className="flex items-center gap-4 border-b border-gold-500/20 bg-navy-800 px-5 py-4" data-id="element-263" data-mp="1yo0higgrm8im">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-gold-500/50 font-display text-lg font-bold text-gold-400" data-id="element-264" data-mp="3o0ltd3qkuexo">
                {playbook.number}
              </span>
              <div className="min-w-0" data-id="element-265" data-mp="ccc5r93kfg61">
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-gold-500" data-id="element-266" data-mp="cbarkvr96dk3">
                  Playbook {playbook.number}
                </p>
                <h3 className="font-display text-xl font-bold leading-tight text-white sm:text-2xl" data-id="element-267" data-mp="l4xmykrjtesr">
                  {playbook.title}
                </h3>
              </div>
            </div>

            <div className="px-5 py-5" data-id="element-268" data-mp="3pivtl6pvv4kf">
              <p className="font-semibold text-white" data-id="element-269" data-mp="3pjxfk68ftbgx">{playbook.tagline}</p>
              <p className="mt-2 text-[15px] leading-relaxed text-slate-300" data-id="element-270" data-mp="7dsk79svw6e7">
                {playbook.description}
              </p>

              <p className="mt-5 text-[11px] font-bold uppercase tracking-[0.18em] text-gold-500" data-id="element-271" data-mp="2clav6b3ez5f">
                You’ll get
              </p>
              <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-272" data-mp="1dtbld1mjud4u">
                {playbook.items.map(item => <li key={item} className="flex items-start gap-2.5 text-[14px] text-slate-200" data-id="element-273" data-mp="1lukbdtj8u2ye">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-500" aria-hidden="true" data-id="element-274" data-mp="1pv36bwgfnp4t" />
                    <span data-id="element-275" data-mp="1uu7fin3cxmv5">{item}</span>
                  </li>)}
              </ul>
            </div>
          </article>)}
      </div>

      <div className="mt-10 flex justify-center" data-id="element-276" data-mp="1zt0qo8v691s5">
        <CtaButton label="Get all 6 playbooks for $27" subLabel="Plus 5 bonuses and 30+ clinical tools" data-id="element-277" data-mp="126tcq8cz9x34" />
      </div>
    </Section>;
}